import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { theme, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const PartnerLineItemHeroDetails = (props: PropsWithChildren) => {
  const { children } = props;

  const { match } = useResponsive();

  // ─── Styles ──────────────────────────────────────────────────────────

  const containerStyles = [styles.container, match([styles.containerXS, undefined])];

  // ─────────────────────────────────────────────────────────────────────

  return <View style={containerStyles}>{children}</View>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    gap: theme.spacing['4'],
  },
  containerXS: {
    alignSelf: 'stretch',
  },
});
